/**
 * 通用js方法封装处理
 */

/**
 * 日期格式化
 * @param {*} date 
 * @returns 
 */
export function timeFormat(date) {
  var d = new Date(date);
  return dateFormat('YYYY-mm-dd HH:MM:SS', d);
}
/**
 * 日期格式化
 * @param {*} time 
 * @param {*} pattern 
 * @returns 
 */
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
/**
 * 日期格式化
 * @param {*} fmt 
 * @param {*} date 
 * @returns 
 */
export function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}
/**
 * 显示时间格式化
 * 显示为：刚刚、x分钟前，x小时前、1天前、xx年xx月xx日 xx时xx分
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}
//计算某个时间到当前时间有多少天
export function daysBetweenDates(dateString) {
  const date1 = new Date(dateString);
  const date2 = new Date(); // 当前日期

  // 设置时间到当天的开始（00:00:00），以确保比较的是日期部分，而不是时间部分
  date1.setHours(0, 0, 0, 0);
  date2.setHours(0, 0, 0, 0);

  // 计算毫秒差值
  const diffInMs = Math.abs(date2 - date1);
  // 将毫秒差值转换为天数
  return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
}
//计算某个时间到当前时间有多少月
export function monthsBetweenDates(dateString) {
  const date1 = new Date(dateString);
  const date2 = new Date(); // 当前时间

  let months;
  months = (date2.getFullYear() - date1.getFullYear()) * 12;
  months -= date1.getMonth() + 1;
  months += date2.getMonth();

  return months;
}

//是否是几天后
export function daysAfterCurrentDate(targetDateString, dayNum) {
  // 创建当前日期的Date对象
  const currentDate = new Date();
  // 创建目标日期的Date对象
  const targetDate = new Date(targetDateString);

  // 获取两个日期的时间戳（毫秒数）
  const currentTimestamp = currentDate.getTime();
  const targetTimestamp = targetDate.getTime();

  // 计算两个日期之间的差异（毫秒数）
  const differenceInMilliseconds = targetTimestamp - currentTimestamp;

  // 将毫秒数转换为天数
  const daysDifference = differenceInMilliseconds / (24 * 60 * 60 * 1000);

  // 由于我们可能需要整数天数，使用Math.ceil或Math.floor来四舍五入
  const day = Math.ceil(daysDifference); // 使用Math.ceil向上取整到最近的天数

  return dayNum >= day;
}

export function getYearDateTime(year) {
  const today = new Date()
  const nextYear = new Date(today.getFullYear() + year, today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), today.getSeconds(), today.getMilliseconds())
  return nextYear
}

/**
 * 
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}
// 小数格式化
export function scaleFormat(value, scale) {
  return Number.parseFloat(value).toFixed(scale);
};
// 小数格式化
export function scale2Format(value) {
  // 判断是否为整数
  if (Number.isInteger(value)) {
    return value.toString()
  }
  // 小数保留2位
  return Number.parseFloat(value).toFixed(2);
};
// 保留2位小数：解决110*1.1 =121.00000000000001 的问题 
export function multiply(a, b) {
  return Math.round(a * b * 100) / 100
}

// 四舍五入
export function roundFormat(value) {
  return Math.round(Number.parseFloat(value));
};

// 设置弹窗标题
export function setDialogTitle(str, len) {
  if (str == '') return '';

  if (str.length > len) {
    return str.substring(0, len) + '...';
  }
  return str;
}

/**
 * 获取url参数值
 * @param {url参数名称} name
 */
export function getUrlKey(name) {
  // eslint-disable-next-line no-sparse-arrays
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

/**
 * 表单重置
 * @param {Object} context - 组件实例的 proxy
 * @param {string} refName - ref 的名称
 */
export function resetForm(context, refName) {
  const formRef = context.$refs[refName];
  // 检查是否为 Form 实例并存在 resetFields 方法
  if (formRef) {
    formRef.resetFields();
  }
}
/**
 * 单个操作设置Ids的值
 */
export function setIdValue(id) {
  var ids = [];
  if (id != undefined && id > 0) {
    ids = Array.of(id)
  }
  return ids;
}
/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}


// // 深度克隆 array 数组或 json 对象，返回克隆后的副本
export function deepObjClone(obj) {
  let weakMap = new WeakMap()
  function clone(obj) {
    if (obj == null) {
      return obj
    }
    if (obj instanceof Date) {
      return new Date(obj)
    }
    if (obj instanceof RegExp) {
      return new RegExp(obj)
    }
    if (typeof obj !== 'object') return obj

    if (weakMap.get(obj)) {
      return weakMap.get(obj)
    }
    var copy = new obj.constructor()
    weakMap.set(obj, copy)
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var value = obj[key]
        copy[key] = clone(value)
      }
    }
    return copy
  }
  return clone(obj)
}

//获取随机编码
export function getSN(str) {
  //声明一个随机数变量，默认为1
  var GetRandomn = 1;
  //js生成时间戳
  var timestamp = new Date().getTime();
  //获取随机范围内数值的函数
  function GetRandom(n) {
    //由随机数+时间戳+1组成
    GetRandomn = Math.floor(Math.random() * n + timestamp + 1);
  }
  //开始调用，获得一个1-100的随机数
  GetRandom("30");
  return str + GetRandomn;
}

//过滤html代码
export function filterHtml(html, maxLength) {
  const regex = /<[^>]+>/g;
  var text = html.replace(regex, '');
  // 截取指定数量的字符
  return text.slice(0, maxLength);
}
//只能输入0-100内的2位小数
export function handleFilterInput(value) {
  // 移除所有非数字和小数点的字符
  let filtered = value.replace(/[^\d.]/g, '');
  // 确保只有一个小数点
  filtered = filtered.replace(/\.+/g, '.');
  // 分割整数和小数部分
  const parts = filtered.split('.');
  // 处理整数部分
  if (parts[0]) {
    let integer = parts[0];
    // 不能以0开头，除非是0.xxx
    if (integer.length > 1 && integer[0] === '0' && integer[1] !== '.') {
      integer = integer.substring(1);
    }
    // 限制最大为100
    if (integer && parseInt(integer) > 100) {
      integer = '100';
    }
    parts[0] = integer;
  }
  // 处理小数部分
  if (parts[1] !== undefined) {
    parts[1] = parts[1].substring(0, 2); // 限制两位小数
  }
  // 重新组合
  const newValue = parts[1] !== undefined ? `${parts[0]}.${parts[1]}` : parts[0];

  // console.log(newValue, 111)
  // console.log(value, 222)
  // 更新值
  if (value !== newValue) {
    return newValue;
  }
  return value;
};

/**
 * 将一维的扁平数组转换为多层级对象
 * @param  {[type]} list 一维数组，数组中每一个元素需包含Id和ParentId两个属性
 * @return {[type]} tree 多层级树状结构
 */
export function jsonToTree(data) {
  // 初始化结果数组，并判断输入数据的格式
  let result = []
  if (!Array.isArray(data)) {
    return result
  }
  // 使用map，将当前对象的id与当前对象对应存储起来
  let map = {}
  data.forEach((item) => {
    map[item.Id] = item
  })
  //
  data.forEach((item) => {
    let parent = map[item.ParentId]
    if (parent) {
      ; (parent.children || (parent.children = [])).push(item)
    } else {
      result.push(item)
    }
  })
  return result
}
